import { Routes, Route, Navigate } from 'react-router-dom';
import PaymentSetup from '../pages/PaymentSetup/PaymentSetup';
import PaymentSuccess from '../pages/PaymentSuccess/PaymentSuccess';
import InviteAccept from '../pages/InviteAccept/InviteAccept';

/**
 * Routes for authenticated users who haven't completed payment setup.
 * All routes redirect to PaymentSetup except the success callback
 * and org invite (users can accept invites before paying).
 */
const PaymentWallRoutes = () => {
  return (
    <Routes>
      <Route path="/billing/setup" element={<PaymentSetup />} />
      <Route path="/billing/success" element={<PaymentSuccess />} />
      <Route path="/org/invite/token/:token" element={<InviteAccept />} />
      <Route path="/org/invite" element={<InviteAccept />} />
      <Route path="*" element={<Navigate to="/billing/setup" replace />} />
    </Routes>
  );
};

export default PaymentWallRoutes;
